<template>
  <div class="h-100">
    <Author/>
    <div class="page-content">
      <div class="container fb">
        <h5 class="text-start c-title">{{$t('sponsors')}}</h5>
        <div class="started-swiper-box">
          <div class="swiper-container get-started">
            <div class="swiper-wrapper">
              <div class="swiper-slide" data-swiper-autoplay="2000">
                <div class="slide-info">
                  <div class="dz-media">
                    <img src="../../../assets/LE_LIEU_UNIQUE_2.png" alt="image"/>
                  </div>
                </div>
              </div>
              <div class="swiper-slide">
                <div class="slide-info">
                  <div class="dz-media">
                    <img src="../../../assets/NBU_1.png" alt="image"/>
                  </div>
                </div>
              </div>
              <div class="swiper-slide">
                <div class="slide-info">
                  <div class="dz-media">
                    <img src="../../../assets/FRISSONS_RADIO_3.png" alt="image"/>
                  </div>
                </div>
              </div>
              <div class="swiper-slide">
                <div class="slide-info">
                  <div class="dz-media">
                    <img src="../../../assets/CAP_FM_4.png" alt="image"/>
                  </div>
                </div>
              </div>
              <div class="swiper-slide">
                <div class="slide-info">
                  <div class="dz-media">
                    <img src="../../../assets/soiree_LU_5.png" alt="image"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-btn">
            <div class="swiper-pagination style-1 flex-1"></div>
          </div>
        </div>

        <div class="mt-3">
          <h5 class="text-start c-title">{{$t('catalog')}}</h5>
          <div class="grid-container">
            <Category v-for="category in categories" :key="category.id" :name="category.name" :id="category.id"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>

import {computed, nextTick, onMounted, ref} from "vue";
import Author from '../layouts/partials/author'
import Category from "@/components/category";
import {useStore} from "vuex";

const store = useStore()

onMounted(() => {
  handleSidebar()
  initSwipe()
  store.dispatch('menu/loadCategories',restaurant_id.value)

})

const restaurant_id = computed(() => store.getters['restaurant/restaurant_id'])
const categories = computed(() => store.getters['menu/categories'])

function initSwipe(){
  // eslint-disable-next-line no-undef
  let swiperGetStarted = new Swiper('.get-started', {
    speed: 500,
    parallax: true,
    slidesPerView: 1,
    spaceBetween: 10,
    loop: true,
    navigation: {
      nextEl: '.swiper-btn-next',
      prevEl: '.swiper-btn-prev',
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    autoplay: {
      delay: 2000,
    },
  });

  swiperGetStarted.init()
}

function handleSidebar(){

  let sidebar = $('.sidebar')
  let toggler = $('.menu-toggler')

  $('.menu-toggler').click(function(){
    sidebar.toggleClass('show');
  });
  $('.menu-toggler').click(function(){
    toggler.toggleClass('show');
  });
}
</script>

<style scoped>
  .grid-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
  }
  .started-swiper-box{
    height: auto;
  }
  .started-swiper-box .dz-media{
    margin: auto auto 0px;
  }
  .started-swiper-box .dz-media img{
    max-width: 90%;
    max-height: 20%;
  }
  .dz-media img{
    width: 350px;
    object-fit: contain;
    height: 120px;
  }
  .dz-media{
    border-radius: 10px;
  }
  .started-swiper-box .slide-info{
    padding-bottom: 0px;
  }
  .c-title{
    margin-left: 20px;
  }
</style>